var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content dash-con"},[_c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"mt-4"},[_c('SiteReportSection')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }